/**
 * Reviews Widgets — Shared JS module
 *
 * Geladen door zowel het Polaris widget als het Carousel widget. Stelt
 * gemeenschappelijke helpers beschikbaar via window.RWS namespace.
 *
 * Beide widget JS-files consumeren via window.RWS.extractRating(...) etc.
 * Als shared.js niet geladen is → silently no-op (geen errors).
 */
(function () {
  'use strict';

  if (window.RWS) return; // dubbelladen voorkomen

  var RWS = {};

  /**
   * Extract rating uit een star-group element.
   * Drie strategies in volgorde van betrouwbaarheid:
   *   1. title attr ("5 sterren" / "5 Stars")
   *   2. aria-label ("5 ster beoordeling")
   *   3. stars__icon--N classes (per ster: 100=full, 50=half, 0=empty)
   *
   * Returns: float 1-5, of 0 als geen geldig rating gevonden.
   */
  RWS.extractRating = function (starGroup) {
    if (!starGroup) return 0;

    // Strategy 1: title attr op starGroup zelf OF child
    var titledEl = starGroup.hasAttribute('title')
      ? starGroup
      : starGroup.querySelector('[title]');
    if (titledEl) {
      var title = titledEl.getAttribute('title') || '';
      var titleMatch = title.match(/([\d.]+)/);
      if (titleMatch) {
        var t = parseFloat(titleMatch[1]);
        if (t > 0 && t <= 5) return t;
      }
    }

    // Strategy 2: aria-label
    var labeledEl = starGroup.hasAttribute('aria-label')
      ? starGroup
      : starGroup.querySelector('[aria-label]');
    if (labeledEl) {
      var aria = labeledEl.getAttribute('aria-label') || '';
      var match = aria.match(/([\d.]+)/);
      if (match) {
        var a = parseFloat(match[1]);
        if (a > 0 && a <= 5) return a;
      }
    }

    // Strategy 3: stars__icon--N OF stars_icon--N classes
    var stars = starGroup.querySelectorAll('[class*="stars_icon--"], [class*="stars__icon--"]');
    if (stars.length > 0) {
      var rating = 0;
      Array.prototype.forEach.call(stars, function (s) {
        var percMatch = (s.className || '').match(/stars_+icon--(\d+)/);
        if (percMatch) rating += parseInt(percMatch[1], 10) / 100;
      });
      if (rating > 0 && rating <= 5) return rating;
    }

    return 0;
  };

  /**
   * Format rating waarde naar "X/5" string.
   * Hele getallen zonder decimal: "5" → "5/5"
   * Halve getallen 1 decimal:    "4.5" → "4.5/5"
   */
  RWS.formatRating = function (rating) {
    if (!rating || rating <= 0 || rating > 5) return '';
    var str = rating % 1 === 0 ? rating.toString() : rating.toFixed(1);
    return str + '/5';
  };

  /**
   * Inject "X/5" label naast star-group.
   * @param {Element} starGroup - .R-RatingStars container
   * @param {string} className - bv. "prw-rating-num" of "rcw-rating-num"
   */
  RWS.injectRating = function (starGroup, className) {
    if (!starGroup || !className) return;
    var rating = RWS.extractRating(starGroup);
    var ratingText = RWS.formatRating(rating);
    if (!ratingText) return;

    // Idempotent: skip als label er al is met juiste content
    var existing = starGroup.querySelector('.' + className);
    if (existing) {
      if (existing.textContent === ratingText) return;
      existing.parentNode.removeChild(existing);
    }

    var label = document.createElement('span');
    label.className = className;
    label.textContent = ratingText;
    label.setAttribute('aria-label', rating + ' uit 5 sterren');
    starGroup.appendChild(label);
  };

  /**
   * Wrap een nummer binnen tekst content in <strong>.
   * Bv. "Gebaseerd op 804 reviews" → "Gebaseerd op <strong>804</strong> reviews"
   *
   * Idempotent via children-presence check (NIET via data-flag, want Reviews.io
   * re-rendert sometimes innerHTML waardoor flag persist maar wrap weg is).
   */
  RWS.wrapCountWithStrong = function (el) {
    if (!el) return;
    if (el.children.length > 0) return; // al gewrapt OF heeft andere children
    var text = el.textContent || '';
    var m = text.match(/^(.*?)([\d.,]+)(\s+\S+.*)$/);
    if (m) {
      el.innerHTML = m[1] + '<strong>' + m[2] + '</strong>' + m[3];
    }
  };

  /**
   * Registreer cleanup voor een widget element op section-unload.
   * Disconnect MutationObservers en clearInterval bij Theme Editor section-toggle.
   *
   * @param {Element} el - widget root element
   * @param {Function} cleanupFn - functie die cleanup uitvoert (disconnect MO, clearInterval, etc.)
   */
  RWS.registerCleanup = function (el, cleanupFn) {
    if (!el || typeof cleanupFn !== 'function') return;

    function handleUnload(e) {
      var target = e && e.target;
      if (!target || target === el || target.contains(el)) {
        try { cleanupFn(); } catch (_) {}
        document.removeEventListener('shopify:section:unload', handleUnload);
      }
    }
    document.addEventListener('shopify:section:unload', handleUnload);
  };

  window.RWS = RWS;
})();
